exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3JrgR,._40Ju-{overflow:hidden;height:auto;padding:0;border-radius:0;border:none;font-size:14px;color:#fff}._3ryEt{width:30px;height:30px;border-width:2px;border-color:#fff;margin-right:7px}.Oo-HK:before{transform:scale(.8);left:2px;position:relative}._3QiaB{width:100%;border-bottom:1px solid #fff;line-height:normal;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration}._40Ju- ._3QiaB{display:inline-block}", ""]);

// exports
exports.locals = {
	"play": "_3JrgR",
	"purchase": "_40Ju-",
	"icon": "_3ryEt",
	"play-icon": "Oo-HK",
	"playIcon": "Oo-HK",
	"text": "_3QiaB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/components/player-overlay/mobile/three-rows-widget/buttons/middle-buttons.styl
// module id = 2808
// module chunks = mobile/mobile